import script from "./LoadingWave.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingWave.vue?vue&type=script&setup=true&lang=js"

import "./LoadingWave.vue?vue&type=style&index=0&id=e2f4c970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f4c970"]])

export default __exports__